var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._b({staticClass:"buybox-reset-button",on:{"click":_setup.handleClick}},'button',_vm.$attrs,false),[_c('FontAwesomeIcon',{attrs:{"icon":_setup.faTimes}}),_vm._v(" "+_vm._s(_vm.$tc('WEBAPP_RESET'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }